export default __webpack_public_path__ + "static/media/breast_plot.3cd3e33b.png";